<template>
  <div id="app">
    <el-row class="headTop pcShow">
    	<el-row class='body'>
      	<el-col :span='2' class="logo" ><img src="/static/images/logo_03.png" alt="" @click='openNewPage("/index")' style="cursor: pointer;"></el-col>
      	<el-col :span='22' class='meun'>
      		<el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect" router>
      				<el-menu-item v-for="(meun, i) in meun" :key="meun.url" :index='meun.url'>{{meun.name}}<br/><font v-html="meun.abc"></font></el-menu-item>
      		</el-menu>
      	</el-col>
     	</el-row>
     	<el-row class="childMeun" v-if='isShow' :key='"level" + isShow'>
 			<el-row class="body">
 				<el-col :span='22' :offset='2' v-if='childType == 1' class='aboutlist'>
 					<p v-for='item in aboutList' :class="{active: item.url == aboutActive}" @click='aboutClick(item)'> {{item.name}}</p>
 				</el-col>
 				<el-col :span='22' :offset='2' v-else-if='childType == 2' class='aboutlist pd-l-348'>
 					<p v-for='item in teamList' :class="{active: item.url == teamActive}" @click='teamClick(item) '> {{item.name}}</p>
 				</el-col>
 				<el-col :span='22' :offset='2' v-else-if='childType == 3' class='aboutlist pd-l-572' style='width:115px; padding-left:3px;'>
 					<p v-for='item in hezuoList' :class="{active: item.url == hehuoActive}" @click='hezuoClick(item) '> {{item.name}}</p>
 				</el-col>
 			</el-row>
     	</el-row>
    </el-row>
    <!--
    	作者：285008074@qq.com
    	时间：2019-09-22
    	描述：移动端适配
    -->
    <el-row class="wapShow">
    	<div class="leftMenu" :style="{opacity: meunShow==true ? '1' : '0'}" :class="{hide: !meunShow}">
				<ul>
					<li v-for="(meun, i) in meun" :key="meun.url" :class="{active : activeIndex == meun.url}" @click='openNewPage(meun.url)'>
						<b>{{meun.name}}</b> 
						<span>{{meun.abc}}</span>
					</li>
				</ul>
			</div>
			<el-row class='headTop'>
				<el-col :span='5'><img src="/static/images/wap/icon_03.jpg" alt="" @click="meunShow = !meunShow"/></el-col>
				<el-col :span='14' style='text-align: center;'><img src="/static/images/wap/logo_04.jpg"/></el-col>
				<el-col :span='5' style='text-align: center;'><img src="/static/images/wap/right.jpg" alt="" @click='openNewPage("/cooperation")' /></el-col>
			</el-row>
			<!--
            	作者：285008074@qq.com
            	时间：2019-09-24
            	描述：子页面
            -->
      <el-row class='child_wap_menu' v-if='isShow' :key='"level" + isShow'>
      	<ul v-if='childType == 1'>
	    		<li v-for='item in aboutList' :class="{active: item.url == aboutActive}" @click='aboutClick(item)' v-html='item.wapname'></li>
	    	</ul>
	    	<ul v-if='childType == 2'>
	    		<li v-for='item in teamList' :class="{active: item.url == teamActive}" @click='teamClick(item)' v-html='item.wapname'></li>
	    	</ul>
	    	<ul v-if='childType == 3'>
	    		<li v-for='item in hezuoList' :class="{active: item.url == hehuoActive}" @click='hezuoClick(item)' v-html='item.wapname'></li>
	    	</ul>
      </el-row>
    </el-row>
    <!---->
    <el-row class='contentBody clearfix'>
	    <transition :name='transitionName'>    
	      <router-view @on-click='isActive'></router-view>
	    </transition>
    </el-row>
		<!---->
    <!--foot-->
    <el-row class='foot'>
    	<el-row class="body">
    		<div class="pcShow">
    			Corpyright © 宝佳国际 . All right reserved . 京ICP备18041314号  &ensp;&ensp;  |   <a href="javaScript:void(0)" @click='openNewPage("/joinus")'>加入我们</a>   |   
    			<a href="javaScript:void(0)"  @click='openNewPage("/contact")'>联系我们</a></div>
    		<div class="wapShow">
    			Corpyright © 宝佳国际 . All right reserved . 京ICP备18041314号  <br/>
    			<a href="javaScript:void(0)" @click='openNewPage("/joinus")'>加入我们</a>   |  <a href="javaScript:void(0)"  @click='openNewPage("/contact")'>联系我们</a>
    		</div>
    	</el-row>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
  	return {
		 	meun: [
        {name : '首页', abc : 'HOME', url:'/index'},
        {name : '公司新闻', abc : 'NEWS', url : '/aboutnews'},
        {name : '宝佳作品', abc : 'PROJECTS', url : '/projects'},
        {name : '关于我们', abc : 'ABOUT US', url : '/company'},
        {name : '宝佳设计服务', abc : 'SERVICES', url : '/services'},
        {name : '团队', abc : 'TEAM', url : '/eliteteam'},
        {name : '宝佳文化', abc : 'CULTURE', url : '/culture'},
        {name : '招商加盟', abc : 'MERCHANTS JOIN', url : '/cooperation'},      			
      ],
   		activeIndex : '/index',
   		transitionName : '',
   		aboutList : [
   	 		{name : 'CEO致辞',wapname: 'CEO<br/>致辞',  url : '/ceo'},
   	 		{name : '公司简介 ',wapname:'公司<br/>简介 ', url : '/company'},          
   	 		{name : '公司理念',wapname:'公司<br/>理念', url: '/corporate_idea'},
   	 		{name : '组织架构',wapname:'组织<br/>架构', url: '/organizational'},
   	 		{name : '大事记',wapname:'大事<br/>记', url: '/events'},
// 	 		{name : '公司新闻',wapname:'公司<br/>新闻', url: '/aboutnews'},
      ],
      teamList:[
      	{name : '精英团队',wapname: '精英<br/>团队', url : '/eliteteam'}, 
   	 		{name : '设计团队 ',wapname: '设计<br/>团队', url : '/teamdesign'},
   	 		{name : '企业招聘 ',wapname: '企业<br/>招聘', url : '/enterprise'},
   	 		{name : '宝佳风貌 ',wapname: '宝佳<br/>风貌', url : '/fengmao'},
      ],
      hezuoList : [
      	{name : '全球合伙人', wapname:"全球<br/>合伙人", url : '/partner_two'}, 
// 	 		{name : '合作工坊 ', wapname:"合作<br/>工坊", url : '/branch_new'},      
      ],
      aboutActive: '/ceo',
      childType: null,
      isShow: false,
      teamActive : '/eliteteam',
      hehuoActive: '',
      centerHeight: window.screen.height + 'px',
      meunShow: false,
	  }
  },
  methods : {
  	openNewPage : function(url){
  		this.activeIndex = url;		
	   	this.$router.push({ path: url});
	  },
  	handleSelect(key) {
  		this.isActive(key);
   	},
   	aboutClick : function(item){
   		this.aboutActive = item.url;
   		this.$router.push({ path:item.url});
   	},
   	teamClick : function(item){
   		this.teamActive = item.url;
   		this.$router.push({ path:item.url});
   	},
   	openNewPage : function(url){
   		this.$router.push({ path: url});
   		localStorage.setItem("childshow", false);
   	},
   	hezuoClick : function(item){
   		this.hehuoActive = item.url;
   		this.$router.push({ path: item.url});
   	},
   	isActive: function(){
   		this.$nextTick( () => {
   			this.isShow = false;
   			let aboutUrl = ['/ceo', '/company', '/corporate_idea','/organizational', '/events'];
				let url_ = window.location.href.split("http://www.acbi.com.cn")[1];
//	      let url_ = window.location.href.split('localhost')[1];

				if(url_.indexOf("?id=") > -1){
	  			url_ = url_.split("?id=")[0];
	  		}
				
	  		this.activeIndex = url_ ;
	  		
	  		aboutUrl.forEach((item) => {
	  			if(item == url_){
	  				this.isShow = true;
	  				this.childType = 1 ;
	  				this.aboutActive = url_;
	  				this.activeIndex = '/ceo';
	  			}
	  		})
	  		if(url_ == "/partner_two" || url_ == "/branch_new" ){
	  			this.isShow = true;
	  			this.childType = 3 ;
	  			this.hehuoActive = url_;
	  			this.activeIndex = '/cooperation';
	  		}
	  		if(url_ == "/eliteteam" || url_ == "/teamdesign" || url_ == '/enterprise' || url_ == '/fengmao'){
	  			this.isShow = true;
	  			this.childType = 2 ;
	  			this.teamActive = url_;
	  			this.activeIndex = '/eliteteam';
	  		}   			
   		})   		
   	},
  },
  watch : {
		$route(to, from) {
      //如果to索引大于from索引,判断为前进状态,反之则为后退状态
      if(to.meta.index > from.meta.index){
	    	//设置动画名称
        this.transitionName = 'slide-left';
      }else{
        this.transitionName = 'slide-right';
      }
      this.meunShow =  false;
      this.isShow = to.meta.childshow == 1 ? true : false;
      if(to.fullPath == "/partner_new" || to.fullPath == '/branch_new'){
      	this.hehuoActive = to.fullPath;
      }
      this.isActive();
    },
    'activeIndex': function(){
    	this.isActive();
    }
  },
  created(){
  		this.isActive();
  },
  mounted(){
  },
  beforeDestroy() {
  	
  }
}
</script>

<style>
body{margin:0; padding:0;overflow-x: hidden;}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #000;
}
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 500ms;
  position: absolute;
}
.slide-right-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
</style>



// WEBPACK FOOTER //
// src/App.vue